import {faExternalLinkAlt as farExternalLinkAlt} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {useInstanceDetailPage} from '../../../api/hooks/useInstanceDetail.hook';
import {DetailedInstance} from '../../../api/models/detailed-instance';
import {TypographyVariantsEnum} from '../../../utils/_enums/typeography-variants.enum';
import {useAppSelector} from '../../../utils/_hooks/hooks';
import Accordion from '../../_shared/accordion/accordion';
import {Typography} from '../../_shared/typography/typography';
import styles from './instance-detail-token-history-box.module.scss';

const TokenHistoryBox = (): JSX.Element => {
    const instance = useAppSelector<DetailedInstance | undefined>(state => state.productSlice.instance);
    const data = useInstanceDetailPage();

    const getEtherscanLink = () => {
        const prefix = Number(process.env.NEXT_PUBLIC_CHAIN_ID) === 5 ? 'goerli.' : '';
        const id = instance
            ? instance.creatoken
                ? instance.token
                : instance.id
            : undefined;
        const contract = instance
            ? instance.creatoken
                ? instance.contract
                : instance.variant?.salesAttribute?.contract?.contractAddress
            : undefined;
        return `https://${prefix}etherscan.io/token/${contract}?a=${id}`;
    }

    if (data && instance && instance.minted) {
        return (
            <Accordion label={data.tokenHistoryHeadline.headlineContent} onlyMobil={true} initialOpen={false}>
                <div className={styles['token-history-box']}>
                    <Typography
                        variant={TypographyVariantsEnum.HEADING4_BOLD}
                        element={'h4'}
                        className={styles['headline']}
                    >
                        {data.tokenHistoryHeadline.headlineContent}
                    </Typography>
                    <Typography
                        variant={TypographyVariantsEnum.BODY}
                        element={'p'}
                        className={styles['description-body']}
                    >
                        {data.tokenHistoryDescriptionLong.content}
                    </Typography>

                    <div className={styles['token-history-box-link-wrapper']}>
                        <FontAwesomeIcon icon={farExternalLinkAlt}/>
                        <div className={styles['token-history-box-link']}>
                            <a href={getEtherscanLink()}>{getEtherscanLink()}</a>
                        </div>
                    </div>
                </div>
            </Accordion>
        )
    } else {
        return <div/>
    }

}

export default TokenHistoryBox;
